module.exports = __webpack_public_path__ + "img/add.992a1623.png";